import { useEffect, useState } from 'react';
import axios from 'axios';
import { getToken } from '../utils';
import OpenandCloseModal from '../TradeCurrency/OpenandCloseModal';
import ModalWithdrawBonus from './ModalWithdrawBonus';
import Modal from '../Components/Modal';

function ReffereSummarry() {
  const [referers, setReferers] = useState([]);

  const { token: userToken } = getToken();
  const { handleOpenandCloseModal, openModal } = OpenandCloseModal();

  useEffect(() => {
    const fetchAllReferes = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/referrals`,
          {
            headers: { Authorization: `Bearer ${userToken}` },
          }
        );
        setReferers(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchAllReferes();
  }, [userToken]);

  const totalCommissons = referers?.reduce((sum, curr) => {
    return sum + curr?.commissions.length > 0
      ? Number(curr?.commissions[0]?.commission)
      : 0;
  }, 0);

  return (
    <section className='items-center w-full bg-p-wh shadow-lg p-6 gap-y-4 flex flex-col md:flex-row '>
      <div className='w-full pr-6'>
        {' '}
        <p className='mb-1 font-semibold text-2xl text-b-mc'>
          Invite friends and
        </p>
        <h2 className='mb-4 font-semibold text-b-mc text-2xl'>
          Receive 20% Bonus{' '}
        </h2>
        <p className='text-s-bk'>
          Invite friends throgh the referer id or referer link to get 20 percent
          bonus on each person you invite
        </p>
      </div>
      <div className=' bg-b-mct p-6 w-full text-s-bk'>
        <p className='flex justify-between pb-1 w-full'>
          Comission:
          <span className='text-[18px] font-semibold text-p-bk'>
            {totalCommissons}
          </span>
        </p>
        <p className='flex justify-between'>
          Referers:
          <span className='text-[18px] font-semibold text-p-bk'>
            {!!referers && referers.length}
          </span>
        </p>
        <div className='mt-6'>
          <button
            type='button'
            className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 w-fit py-2 px-8 disabled:bg-b-mct bg-b-mc rounded relative'
            onClick={() => handleOpenandCloseModal('withdrawbonus')}
          >
            Withdraw bonus
          </button>
        </div>
      </div>
      <Modal open={openModal === 'withdrawbonus'}>
        <ModalWithdrawBonus handleOpenandCloseModal={handleOpenandCloseModal} />
      </Modal>
    </section>
  );
}

export default ReffereSummarry;
